import 'slick-carousel';

const $win = $(window);
const $doc = $(document);

initSlider({
  wrapper: $('.slider-images'),
  dots: true,
  fade: true,
  autoplay: true
});

function initSlider(slider) {
  const $slider = slider.wrapper;
  const $slides = $slider.find('.slider__slides');

  let _dots = slider.dots != undefined ? slider.dots : false;
  let _arrows = slider.arrows != undefined ? slider.arrows : false;
  let _arrowsMobile = slider.arrowsMobile != undefined ? slider.arrowsMobile : false;
  let _fade = slider.fade != undefined ? slider.fade : false;
  let _vertical = slider.vertical != undefined ? slider.vertical : false;
  let _autoplay = slider.autoplay != undefined ? slider.autoplay : false;
  let _autoplaySpeed = slider.autoplaySpeed != undefined ? slider.autoplaySpeed : 5000;
  let _slidesToShow = slider.slidesToShow != undefined ? slider.slidesToShow : 1;
  let _slidesToShowTablet = slider.slidesToShowTablet != undefined ? slider.slidesToShowTablet : _slidesToShow;
  let _slidesToShowMobile = slider.slidesToShowMobile != undefined ? slider.slidesToShowMobile : _slidesToShow;
  let _centerMode = slider.centerMode != undefined ? slider.centerMode : false;
  let _speed = slider.speed != undefined ? slider.speed : 500;

  $slides.slick({
    dots: _dots,
    arrows: _arrows,
    slidesToShow: _slidesToShow,
    slidesToScroll: 1,
    speed: _speed,
    centerMode: _centerMode,
    variableWidth: false,
    adaptiveHeight: true,
    vertical: _vertical,
    fade: _fade,
    autoplay: _autoplay,
    autoplaySpeed: _autoplaySpeed,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: _slidesToShowTablet
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: _slidesToShowMobile,
          arrows: _arrowsMobile
        }
      }
    ]
  });

  if (slider.currentSlide != undefined) {
    $slider.on('afterChange', function(slick, currentSlide) {
      let currentSlideNumber = currentSlide.currentSlide + 1;
      slider.currentSlide.html(currentSlideNumber);

      if (currentSlideNumber < 10) {
        slider.currentSlide.html('0' + currentSlideNumber);
      }
    });
  }
}
